export const extractErrorMessage = function (error: any): string {
    return (
        error?.response?.data?.error ??
        error?.message ??
        "Unknown Error Occurred"
    );
};